import { createBlueprint as e } from "@made-people/blueprint";
const a = e({
  slots: {
    base: "h-[45vw]",
    itemWrapper: "",
    image: "",
    titleWrapper: "",
    title: "text-heading-2xl data-[is-active=true]:text-white"
  },
  variants: {
    baseFunctionality: {
      true: {
        base: "hidden lg:flex w-full justify-center",
        itemWrapper: "flex justify-center items-center group relative",
        image: "w-full h-full absolute left-0 right-0 object-cover top-0 bottom-0 scale-x-0 transition-transform group-hover:scale-x-100 group-focus:scale-x-100",
        titleWrapper: "z-10 w-full flex justify-center items-center h-full",
        title: "rotate-[-90deg] text-center"
      }
    },
    spacingY: {
      none: {
        base: "my-component-y-spacing-none"
      },
      "3xs": {
        base: "my-component-y-spacing-3xs"
      },
      "2xs": {
        base: "my-component-y-spacing-2xs"
      },
      xs: {
        base: "my-component-y-spacing-xs"
      },
      sm: {
        base: "my-component-y-spacing-sm"
      },
      md: {
        base: "my-component-y-spacing-md"
      },
      lg: {
        base: "my-component-y-spacing-lg"
      },
      xl: {
        base: "my-component-y-spacing-xl"
      },
      "2xl": {
        base: "my-component-y-spacing-2xl"
      },
      "3xl": {
        base: "my-component-y-spacing-3xl"
      }
    },
    spacingX: {
      none: {
        base: "mx-component-x-spacing-none w-full"
      },
      xs: {
        base: "mx-component-y-spacing-xs w-[calc(100%-(var(--component-y-spacing-xs)*2))]"
      },
      sm: {
        base: "mx-component-y-spacing-sm w-[calc(100%-(var(--component-y-spacing-sm)*2))]"
      },
      md: {
        base: "mx-component-y-spacing-md w-[calc(100%-(var(--component-y-spacing-md)*2))]"
      },
      lg: {
        base: "mx-component-y-spacing-lg w-[calc(100%-(var(--component-y-spacing-lg)*2))]"
      }
    },
    maxWidth: {
      none: {
        base: "max-w-component-max-w-none"
      },
      sm: {
        base: "max-w-component-max-w-sm"
      },
      md: {
        base: "max-w-component-max-w-md"
      },
      lg: {
        base: "max-w-component-max-w-lg"
      }
    }
  },
  defaultVariants: {
    baseFunctionality: "true",
    spacingX: {
      initial: "xs",
      lg: "sm"
    },
    spacingY: {
      initial: "lg",
      lg: "3xl"
    }
  }
});
export {
  a as linksHorizontalImagesStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
